// extracted by mini-css-extract-plugin
export default {"Container":"Dots_Container__VYL7B","ball":"Dots_ball__8PkNL","bounce":"Dots_bounce__y30Mt"};